import { PartnerWebLabels } from 'libs/shared-lib/interfaces';
import { ABOUT_US_LABELS_DE } from './about-us/about-us.de';
import { CHECKOUTS_LABELS_DE } from './checkouts/checkouts.de';
import { FOOTER_LABELS_DE } from './footer/footer.de';
import { HOME_LABELS_DE } from './home/home.de';
import { LOCATIONS_LABELS_DE } from './locations/locations.de';
import { NAV_LABELS_DE } from './nav/nav.de';
import { NEWS_LABELS_DE } from './news/news.de';
import { NOT_FOUND_LABELS_DE } from './not-found/not-found.de';
import { PROMOTION_NOT_AVAILABLE_LABELS_DE } from './promotion-not-available/promotion-not-available.de';
import { PROMOTION_LABELS_DE } from './promotions/promotions.de';
import { SERVICE_LABELS_DE } from './service/service.de';

export const PARTNER_WEB_LABELS_DE: PartnerWebLabels.Labels = {
    home: HOME_LABELS_DE,
    checkouts: CHECKOUTS_LABELS_DE,
    locations: LOCATIONS_LABELS_DE,
    news: NEWS_LABELS_DE,
    promotions: PROMOTION_LABELS_DE,
    aboutUs: ABOUT_US_LABELS_DE,
    service: SERVICE_LABELS_DE,
    promotionNotAvailablePage: PROMOTION_NOT_AVAILABLE_LABELS_DE,
    notFoundPage: NOT_FOUND_LABELS_DE,
    footer: FOOTER_LABELS_DE,
    nav: NAV_LABELS_DE,
};
